
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevIllustrationSource } from '@ds/components/IllustrationSource'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import {
  trackLandingBannerClick,
  trackLandingBannerImpression,
} from '@tracking/events'

export default {
  components: {
    RevIllustration,
    RevIllustrationSource,
    RevCard,
  },

  props: {
    position: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters({
      listMarketingContent: 'landing/listMarketingContent',
    }),
    hasUrl() {
      return !isEmpty(this.listMarketingContent.link)
    },
    isExternalLink() {
      return (
        this.hasUrl && /^https?:\/\//.test(this.listMarketingContent.link.url)
      )
    },
    wrapperImageTag() {
      return this.hasUrl ? RevButtonBase : 'div'
    },
    wrapperImageProps() {
      return this.hasUrl
        ? {
            'aria-label': this.listMarketingContent.link.text,
            target: this.isExternalLink ? '_blank' : '_self',
            to: this.listMarketingContent.link.url,
          }
        : {}
    },
    eventType() {
      return this.hasUrl ? 'click' : null
    },
  },

  watch: {
    $route() {
      this.watchAdvertInViewport()
    },
  },

  destroyed() {
    if (typeof this.unobserve === 'function') {
      this.unobserve()
    }
  },

  mounted() {
    this.watchAdvertInViewport()
  },

  methods: {
    trackClick() {
      trackLandingBannerClick({
        name: 'landing_page',
        creative: this.listMarketingContent.alt,
        position: `landing_page_${this.position}`,
      })
    },
    watchAdvertInViewport() {
      if (!isEmpty(this.listMarketingContent)) {
        this.unobserve = createObserver(this.$el, () => {
          trackLandingBannerImpression({
            name: 'landing_page',
            creative: this.listMarketingContent.alt,
            position: `landing_page_${this.position}`,
          })
        })
      }
    },
  },
}
